// Registers the PWA service worker (web/public/sw.js).
//
// CONSUMER: internal-ui (employees only)
//
// Production-only: in dev, a service worker fights Vite's module server
// and makes "why is my change not showing" debugging miserable, and the
// worker only caches hashed build assets that dev doesn't produce.
//
// The visibilitychange hook matters more for an installed app than a
// browser tab: a home-screen app can sit backgrounded for days, so we
// ask the browser to re-check /sw.js each time it comes back to the
// foreground. Updates apply immediately (the worker skipWaiting()s) —
// there is no update UI to build.

export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") {
            registration.update().catch(() => {
              // Offline or a transient network failure — the next
              // foreground will try again. Nothing to surface.
            });
          }
        });
      })
      .catch(() => {
        // Registration failing must never affect the app itself — the
        // OS works identically without a service worker; only the
        // installed-app niceties are lost.
      });
  });
}
